import React, {Component} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

class Transfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transferAmt: '',
            transferToAddr: ''
        };

        this.handleTransferAmtChange = this.handleTransferAmtChange.bind(this);
        this.handleTransferSend = this.handleTransferSend.bind(this);
        this.handleExitSend = this.handleExitSend.bind(this);
        this.handleTransferAddressChange = this.handleTransferAddressChange.bind(this);
    }


    handleTransferAmtChange(event) {
        let val = event.target.value;
        this.setState({
            transferAmt: val
        });
    }

    async handleTransferSend() {
        let addr = this.state.transferToAddr;
        let amt = this.state.transferAmt;

        if (amt <= 0) {
            toast.error(this.props.data.txtResponse.transfer.amtNotZero);
            console.log(this.props.data.txtResponse.transfer.amtNotZero);
            return;
        }
        if (!this.props.data.web3.utils.isAddress(addr)) {
            toast.error(this.props.data.txtResponse.transfer.addressNotValid);
            console.log(this.props.data.txtResponse.transfer.addressNotValid);
            return;
        }
        let serialized = this.props.data.web3.utils.toWei(amt);
        try {
            await this.props.data.P3XTokenContract.methods.transfer(addr, serialized).send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.transfer.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    handleTransferAddressChange(event) {
        let val = event.target.value;
        this.setState({
            transferToAddr: val
        });
    }

    async handleExitSend() {
        try {
            await this.props.data.P3XTokenContract.methods.exit().send({
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.exit.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    render() {
        return (

            <div className="row">
                <div className="col-12 mt-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <h5 className="card-title text-center">Transfer P3X</h5>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Amount:</span>
                                        </div>
                                        <input id="transfer-p3x-amount" type="number" className="form-control" value={this.state.transferAmt} onChange={this.handleTransferAmtChange}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">P3X</span>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Address:</span>
                                        </div>
                                        <input id="transfer-p3x-address" type="text" className="form-control" value={this.state.transferToAddr} onChange={this.handleTransferAddressChange}/>
                                    </div>
                                    <button id="btn-transfer" type="button" className="btn btn-primary btn-block" onClick={this.handleTransferSend}>Transfer</button>

                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
                                    <div style={{textAlign: 'center'}}>
                                        <h5 className="card-title" style={{display: 'inline-block'}}>
                                            Exit P3X
                                        </h5>
                                    </div>
                                    <div className="form-group row" style={{marginBottom: '0'}}>
                                        <div className="col-12 text-center">
                                            <p style={{fontSize: '13px'}}>Are you done earning free ETH? Want to get out? Exit will immediately sell all your P3X and withdraw the ETH to your wallet.
                                                You cannot Exit with an active Gauntlet.</p>
                                        </div>
                                    </div>
                                    <div className="form-group row" style={{marginBottom: '0'}}>
                                        <div className="col-12 text-center">
                                            <button type="button" id="exit" className="btn btn-primary btn-block" onClick={this.handleExitSend}>Exit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>

        );
    }
}

export default Transfer;